import messageState from './state/messageState';
import { CLICK_SIGN_BUTTON, SEND, GET_LOGIN, GET_PASSWORD } from '../actions/actionConst';

const patch = ["/petycja", "login"];

const messageReducer = (state = messageState, action) => {
    switch(action.type) {
        case CLICK_SIGN_BUTTON:
            return {
                ...state,
                actualPath: "/login"
            }

        case SEND:
            return state;

        case GET_LOGIN:
            return {
                ...state,
                login: action.login
            }

        case GET_PASSWORD:
            return {
                ...state,
                password: action.password
            }

        default:
            return state;
    }
}

export default messageReducer;